<template>
    <div class="form-group mb-3">
      <label :for="'output' + inputID" class="text-label">
        {{ outputLabel }}{{ noColon ? '' : ':' }}&nbsp;
      </label>
      <input
        :value="prefix + number"
        disabled
        class="calc-input-width me-1"
        :id="'output' + inputID"
      />
      <span v-if="tooltip">
        <abbr :title="tooltip">{{ unit }}</abbr>
      </span>
      <span v-else>{{ unit }}</span>
    </div>
  </template>
  
  <script>
  //import { ref } from 'vue';
  import newId from '../../utils/unique_key';
  
  export default {
    name: 'FixedUnitOutput',
    props: {
      outputLabel: {
        type: String,
        required: true,
        default: ''
      },
      number: {
        type: Number,
        required: true,
        default: 0
      },
      unit: {
        type: String,
        default: 'units'
      },
      noColon: {
        type: Boolean,
        default: false
      },
      prefix: {
        type: String,
        default: ''
      },
      tooltip: {
        type: String,
        default: null
      }
    },
    setup() {
      const inputID = newId();
      return { inputID };
    }
  };
  </script>
  